/* ===========================================================================
   HOFFMANN 12.09.2026 - Neue Schnellansicht, Fenster.

   Gehoert zu sections/hf-quickview.liquid (Markup, geliefert ueber
   /products/<handle>?view=hf-quickview) und assets/hf-quickview-panel.css.

   Der Ausloeser auf den Produktkacheln (Leiste "Hinzufuegen" ab 1024 px mit
   Maus, sonst Plus unten rechts) bleibt unveraendert in
   snippets/product-item.liquid. Dieses Skript faengt den Klick in der
   Capture-Phase ab, bevor Focals ToggleButton ihn sieht, und oeffnet statt der
   alten Schnellansicht (quick-buy-drawer / -popover) dieses Fenster. Es gibt
   genau EIN Fenster; ein neuer Ausloeser tauscht nur den Inhalt.

   Fokusfalle, Escape, Klick auf den Schleier und die Scroll-Sperre sind hier
   selbst umgesetzt, damit das Fenster nicht von Focals Drawer-Styling abhaengt.
   =========================================================================== */
(function () {
  'use strict';

  if (window.__hfQuickviewBound) return;
  window.__hfQuickviewBound = true;

  var TRIGGER = '.hf-qa__bar, .hf-qa__plus, [data-hf-qv-open]';
  var LOCK_CLASS = 'hf-qv-locked';
  var win = null;      // Fensterrahmen
  var slot = null;     // Aufnahme fuer das gefetchte Panel
  var veil = null;
  var openerEl = null; // Ausloeser, fuer die Fokusrueckgabe
  var currentUrl = null;
  var cache = {};
  var state = null;    // Zustand des offenen Panels

  /* ------------------------------------------------------------- Hilfsmittel */

  function formatMoney(cents) {
    var euros = cents / 100;
    if (cents % 100 === 0) {
      return euros.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
    }
    return euros.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 1024px)').matches;
  }

  var IMG_SIZES = '(min-width: 1024px) 340px, 130px';

  function srcsetFor(src) {
    return [240, 480, 720, 1200].map(function (w) {
      return src.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w';
    }).join(', ');
  }

  /* Alle Bilder der aktiven Gruppe vorladen, damit das Wischen am Handy nicht
     auf das Netz warten muss. Der Vorlader nutzt dasselbe srcset und sizes wie
     das sichtbare Bild, sonst waehlt der Browser eine andere Datei. */
  function preloadMedia(list) {
    for (var i = 0; i < list.length; i++) {
      var pre = new Image();
      pre.sizes = IMG_SIZES;
      pre.srcset = srcsetFor(list[i].src);
      pre.src = list[i].src;
    }
  }

  function productUrlFrom(trigger) {
    if (trigger.getAttribute('data-hf-qv-open')) {
      return trigger.getAttribute('data-hf-qv-open').split('?')[0];
    }
    var card = trigger.closest('product-item, .hf-card, .product-item, li, .card');
    var link = card && card.querySelector('a[href*="/products/"]');
    if (link) return link.getAttribute('href').split('?')[0];
    var id = trigger.getAttribute('aria-controls');
    var host = id && document.getElementById(id);
    var href = host && host.getAttribute('href');
    if (href) return href.split('?')[0];
    return null;
  }

  /* ------------------------------------------------------------- Fensterbau */

  function buildWindow() {
    if (win) return;

    var root = document.createElement('div');
    root.className = 'hf-qv';
    root.id = 'hf-qv';
    root.innerHTML =
      '<span class="hf-qv__veil" data-hf-qv-veil></span>' +
      '<div class="hf-qv__window" role="dialog" aria-modal="true" tabindex="-1" data-hf-qv-window>' +
      '<div data-hf-qv-slot></div>' +
      '</div>';
    document.body.appendChild(root);

    win = root;
    slot = root.querySelector('[data-hf-qv-slot]');
    veil = root.querySelector('[data-hf-qv-veil]');

    veil.addEventListener('click', close);
    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-hf-qv-close]')) {
        event.preventDefault();
        close();
      }
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        event.preventDefault();
        var layer = samplesLayer();
        if (layer && layer.classList.contains('is-open')) {
          closeSamplesLayer();
          return;
        }
        var rp = reviewPanel();
        if (rp && !rp.hidden) {
          closeReviews();
          return;
        }
        close();
        return;
      }
      if (event.key === 'Tab') trapFocus(event);
    });

    bindSheetGestures(root.querySelector('[data-hf-qv-window]'));
  }

  function focusables() {
    /* Ist eine Ebene offen, bleibt der Fokus in ihr */
    var scope = win.querySelector('.hf-sm-layer.is-open') ||
      win.querySelector('.hf-qv-reviews.is-open') || win;
    var nodes = scope.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    return Array.prototype.filter.call(nodes, function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function trapFocus(event) {
    var list = focusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ------------------------------------------------------- Oeffnen/Schliessen */

  function open(url, trigger) {
    buildWindow();
    openerEl = trigger || null;
    currentUrl = url;
    win.classList.remove('hf-qv--samples');

    if (!win.hasAttribute('open')) {
      document.documentElement.classList.add(LOCK_CLASS, 'lock-all');
      win.setAttribute('open', '');
    }

    if (!cache[url]) {
      slot.innerHTML = '<div class="hf-qv-panel"><p class="hf-qv__loader">Wird geladen</p></div>';
    }

    load(url).then(function (html) {
      if (currentUrl !== url) return;
      slot.innerHTML = html;
      var panel = slot.querySelector('[data-hf-qv-panel]');
      if (!panel) {
        window.location.href = url;
        return;
      }
      var winEl = win.querySelector('[data-hf-qv-window]');
      winEl.setAttribute('aria-label', panel.getAttribute('aria-label') || '');
      initPanel(panel);
      if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
        try { window.Shopify.PaymentButton.init(); } catch (err) {}
      }
      requestAnimationFrame(function () { winEl.focus(); });
    })['catch'](function () {
      if (currentUrl === url) window.location.href = url;
    });
  }

  function load(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return fetch(url + sep + 'view=hf-quickview', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('quickview ' + response.status);
        return response.text();
      })
      .then(function (text) {
        cache[url] = text;
        return text;
      });
  }

  function close() {
    if (!win || !win.hasAttribute('open')) return;
    samples = null;
    win.classList.remove('hf-qv--samples', 'hf-qv--samples-layer');
    win.removeAttribute('open');
    document.documentElement.classList.remove(LOCK_CLASS, 'lock-all');
    currentUrl = null;
    state = null;
    if (openerEl && document.contains(openerEl)) {
      var target = openerEl;
      if (!target.offsetWidth && !target.offsetHeight) {
        /* Die Leiste ist nur beim Ueberfahren sichtbar, ein unsichtbares
           Element nimmt keinen Fokus: dann auf die Kachel zurueckgeben. */
        var card = openerEl.closest('product-item, .hf-card, .product-item');
        target = (card && card.querySelector('a[href*="/products/"]')) || openerEl;
      }
      try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
    }
    openerEl = null;
  }

  /* ------------------------------------------------------ Wischen im Sheet -- */

  /* Das Sheet folgt dem Finger nur, wenn unter der Beruehrung nichts mehr nach
     oben zu scrollen ist. Geprueft wird der tatsaechliche Scrollbereich unter
     dem Finger, also auch Musterfenster und Bewertungen und nicht nur
     .hf-qv__body. Dazu eine tote Zone und die Bedingung, dass die erste
     deutliche Bewegung nach unten zeigt: sonst schliesst schon das Hochscrollen
     in einer Liste das Fenster. */

  var SHEET_DEAD = 16;    // erst ab hier folgt das Sheet dem Finger
  var SHEET_CLOSE = 120;  // ab hier wird losgelassen geschlossen

  function scrollerUnder(node, root) {
    while (node && node.nodeType === 1) {
      if (node.scrollHeight - node.clientHeight > 1) {
        var flow = window.getComputedStyle(node).overflowY;
        if (flow === 'auto' || flow === 'scroll') return node;
      }
      if (node === root) break;
      node = node.parentNode;
    }
    return null;
  }

  /* Nach unten wischen schliesst das, was gerade obenauf liegt: erst die
     Musterebene, dann die Bewertungen, erst dann das Fenster. Wie Escape. */
  function dismissSheet() {
    var layer = samplesLayer();
    if (layer && layer.classList.contains('is-open')) {
      closeSamplesLayer();
      return;
    }
    var rp = reviewPanel();
    if (rp && !rp.hidden) {
      closeReviews();
      return;
    }
    close();
  }

  function bindSheetGestures(winEl) {
    var startX = 0;
    var startY = 0;
    var delta = 0;
    var armed = false;
    var dragging = false;
    var dropped = false;

    function reset() {
      armed = false;
      dragging = false;
      dropped = false;
      delta = 0;
      winEl.style.transition = '';
      winEl.style.transform = '';
    }

    winEl.addEventListener('touchstart', function (event) {
      armed = false;
      dragging = false;
      dropped = false;
      delta = 0;
      if (isDesktop() || event.touches.length !== 1) return;
      if (event.target.closest('.hf-qv__stage')) return;
      var scroller = scrollerUnder(event.target, winEl);
      if (scroller && scroller.scrollTop > 0) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      armed = true;
    }, { passive: true });

    winEl.addEventListener('touchmove', function (event) {
      if (!armed || dropped) return;
      var dy = event.touches[0].clientY - startY;
      var dx = event.touches[0].clientX - startX;

      if (!dragging) {
        if (Math.abs(dy) < SHEET_DEAD && Math.abs(dx) < SHEET_DEAD) return;
        /* Nach oben oder quer heisst scrollen bzw. blaettern: dann bleibt das
           Sheet fuer den Rest dieser Geste stehen. */
        if (dy <= 0 || Math.abs(dx) > Math.abs(dy)) {
          dropped = true;
          return;
        }
        dragging = true;
      }

      delta = dy - SHEET_DEAD;
      if (delta < 0) delta = 0;
      winEl.style.transition = 'none';
      winEl.style.transform = 'translateY(' + delta + 'px)';
    }, { passive: true });

    function finish() {
      if (!armed) return;
      var far = dragging && delta > SHEET_CLOSE;
      reset();
      if (far) dismissSheet();
    }

    winEl.addEventListener('touchend', finish);
    winEl.addEventListener('touchcancel', finish);
  }

  /* --------------------------------------------------------- Panel-Logik --- */

  function initPanel(panel) {
    var configEl = panel.querySelector('[data-hf-qv-config]');
    var config = {};
    try { config = JSON.parse(configEl.textContent); } catch (err) { return; }

    state = {
      panel: panel,
      config: config,
      colorIndex: config.colorPosition ? config.colorPosition - 1 : -1,
      selected: [],
      media: [],
      mediaIndex: 0
    };
    for (var i = 0; i < config.optionCount; i++) state.selected.push(null);

    /* Farbe vorwaehlen: erste lieferbare, sonst erste */
    var colorsWrap = panel.querySelector('[data-hf-qv-colors]');
    if (colorsWrap && state.colorIndex > -1) {
      var swatches = colorsWrap.querySelectorAll('.hf-qv__swatch');
      var picked = null;
      for (var s = 0; s < swatches.length; s++) {
        var value = swatches[s].getAttribute('data-value');
        if (!picked && optionAvailable(state.colorIndex, value)) picked = value;
      }
      if (!picked && swatches.length) picked = swatches[0].getAttribute('data-value');
      state.selected[state.colorIndex] = picked;
    }

    /* Optionen mit nur einem Wert brauchen keine Auswahl */
    var singles = panel.querySelectorAll('[data-hf-qv-opt]');
    for (var f = 0; f < singles.length; f++) {
      var rows = singles[f].querySelectorAll('[data-hf-qv-opt-row]');
      if (rows.length === 1) {
        var pos = parseInt(singles[f].getAttribute('data-position'), 10) - 1;
        state.selected[pos] = rows[0].getAttribute('data-value');
      }
    }

    bindShortdesc(panel);
    bindGallery(panel);
    bindColors(panel);
    bindOptions(panel);
    bindQuantity(panel);
    bindReviews(panel);

    var samplesTrigger = panel.querySelector('[data-hf-qv-samples]');
    if (samplesTrigger) {
      samplesTrigger.addEventListener('click', function () {
        openSamplesLayer(state.config.url || window.location.pathname);
      });
    }

    renderMedia();
    update();
  }

  /* ----------------------------------------------------------- Verfuegbarkeit */

  function optionAvailable(index, value) {
    var variants = state.config.variants;
    var selected = state.selected;
    for (var v = 0; v < variants.length; v++) {
      if (!variants[v].available) continue;
      if (variants[v].options[index] !== value) continue;
      var ok = true;
      for (var o = 0; o < selected.length; o++) {
        if (o === index) continue;
        if (selected[o] !== null && variants[v].options[o] !== selected[o]) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }

  function priceFor(index, value) {
    var variants = state.config.variants;
    var selected = state.selected;
    var min = null;
    for (var v = 0; v < variants.length; v++) {
      if (variants[v].options[index] !== value) continue;
      var ok = true;
      for (var o = 0; o < selected.length; o++) {
        if (o === index) continue;
        if (selected[o] !== null && variants[v].options[o] !== selected[o]) { ok = false; break; }
      }
      if (!ok) continue;
      if (min === null || variants[v].price < min) min = variants[v].price;
    }
    return min;
  }

  function currentVariant() {
    for (var i = 0; i < state.selected.length; i++) {
      if (state.selected[i] === null) return null;
    }
    var variants = state.config.variants;
    for (var v = 0; v < variants.length; v++) {
      var hit = true;
      for (var o = 0; o < state.selected.length; o++) {
        if (variants[v].options[o] !== state.selected[o]) { hit = false; break; }
      }
      if (hit) return variants[v];
    }
    return null;
  }

  function minPrice() {
    var variants = state.config.variants;
    var selected = state.selected;
    var min = null;
    for (var v = 0; v < variants.length; v++) {
      var ok = true;
      for (var o = 0; o < selected.length; o++) {
        if (selected[o] !== null && variants[v].options[o] !== selected[o]) { ok = false; break; }
      }
      if (!ok) continue;
      if (min === null || variants[v].price < min) min = variants[v].price;
    }
    return min;
  }

  /* ------------------------------------------------------- Kurzbeschreibung */

  /* Der Text steht vollstaendig im Markup und wird optisch auf drei Zeilen
     begrenzt. Der Knopf erscheint nur, wenn dabei wirklich etwas wegfaellt,
     und klappt im Fenster auf, statt auf die Produktseite zu schicken. */
  function bindShortdesc(panel) {
    var text = panel.querySelector('[data-hf-qv-shortdesc]');
    var more = panel.querySelector('[data-hf-qv-more]');
    if (!text || !more) return;

    /* Mehrfach messen: direkt nach dem Einfuegen steht das Panel noch nicht
       im Layout, und die eigene Schrift kommt erst danach. */
    function check() {
      if (!document.contains(text)) return;
      more.hidden = !(text.scrollHeight - text.clientHeight > 2) && !text.classList.contains('is-expanded');
    }
    requestAnimationFrame(check);
    window.setTimeout(check, 250);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
    window.addEventListener('resize', check);

    more.addEventListener('click', function () {
      var expanded = text.classList.toggle('is-expanded');
      more.textContent = expanded ? 'weniger' : 'mehr lesen';
    });
  }

  /* ------------------------------------------------------------------ Bilder */

  function visibleMedia() {
    var all = state.config.media || [];
    if (!all.length) return [];
    if (state.colorIndex < 0 || state.config.groupCount < 2) return all;

    var groups = state.config.colorGroups || {};
    var startId = groups[state.selected[state.colorIndex]];
    if (!startId) return all;

    var out = [];
    var current = null;
    for (var i = 0; i < all.length; i++) {
      if (all[i].isGroup) current = all[i].id;
      if (current === null || current === startId) out.push(all[i]);
    }
    return out.length ? out : all;
  }

  function renderMedia(keepIndex) {
    var panel = state.panel;
    var list = visibleMedia();
    state.media = list;

    var startId = null;
    if (state.colorIndex > -1 && state.config.colorGroups) {
      startId = state.config.colorGroups[state.selected[state.colorIndex]] || null;
    }
    var index = 0;
    if (keepIndex && state.mediaIndex < list.length) {
      index = state.mediaIndex;
    } else if (startId) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].id === startId) { index = i; break; }
      }
    }
    state.mediaIndex = index;

    var thumbs = panel.querySelector('[data-hf-qv-thumbs]');
    if (thumbs) {
      if (list.length > 1) {
        var html = '';
        for (var t = 0; t < list.length; t++) {
          html += '<button type="button" data-hf-qv-thumb="' + t + '" aria-label="Bild ' + (t + 1) + '">' +
            '<img src="' + list[t].thumb + '" alt="" loading="lazy" decoding="async" width="120" height="150">' +
            '</button>';
        }
        thumbs.innerHTML = html;
      } else {
        thumbs.innerHTML = '';
      }
    }

    var dots = panel.querySelector('[data-hf-qv-dots]');
    if (dots) {
      if (list.length > 1) {
        var dotHtml = '';
        for (var d = 0; d < list.length; d++) dotHtml += '<span></span>';
        dots.innerHTML = dotHtml;
        dots.hidden = false;
      } else {
        dots.innerHTML = '';
        dots.hidden = true;
      }
    }

    showMedia(index);
    preloadMedia(list);
    updateThumbFade();
  }

  /* Mehr als vier Vorschaubilder: die Leiste wird seitlich scrollbar und
     bekommt rechts eine Verlaufskante als Hinweis. */
  function updateThumbFade() {
    var wrap = state.panel.querySelector('[data-hf-qv-thumbswrap]');
    var row = state.panel.querySelector('[data-hf-qv-thumbs]');
    if (!wrap || !row) return;
    var scrollable = row.scrollWidth - row.clientWidth > 2;
    wrap.classList.toggle('is-scrollable', scrollable);
    wrap.classList.toggle('is-start', row.scrollLeft <= 2);
    wrap.classList.toggle('is-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 2);
  }

  /* Pfeile an der Vorschaubildleiste. Sie sind fuer die Maus ohne seitliches
     Scrollrad gedacht und erscheinen nur, wenn die Leiste wirklich scrollbar
     ist, und jeweils nur auf der Seite, zu der es noch weitergeht. Gebaut wird
     im JS, damit sections/hf-quickview.liquid unveraendert bleibt. */
  function buildThumbNav(panel) {
    var wrap = panel.querySelector('[data-hf-qv-thumbswrap]');
    var row = panel.querySelector('[data-hf-qv-thumbs]');
    if (!wrap || !row || wrap.querySelector('[data-hf-qv-thumbnav]')) return;

    function arrow(dir, label, path) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'hf-qv__thumbnav hf-qv__thumbnav--' + (dir < 0 ? 'prev' : 'next');
      button.setAttribute('data-hf-qv-thumbnav', dir);
      button.setAttribute('aria-label', label);
      button.innerHTML = '<svg width="13" height="13" viewBox="0 0 16 16" fill="none" ' +
        'stroke="currentColor" stroke-width="1.2" stroke-linecap="round" ' +
        'stroke-linejoin="round" aria-hidden="true"><path d="' + path + '"/></svg>';
      button.addEventListener('click', function () {
        var step = Math.max(Math.round(row.clientWidth * 0.8), 80);
        try {
          row.scrollBy({ left: dir * step, behavior: 'smooth' });
        } catch (err) {
          row.scrollLeft += dir * step;
        }
      });
      return button;
    }

    wrap.appendChild(arrow(-1, 'Vorherige Bilder', 'M10 2.5L4.5 8l5.5 5.5'));
    wrap.appendChild(arrow(1, 'Weitere Bilder', 'M6 2.5L11.5 8 6 13.5'));
  }

  function showMedia(index) {
    var panel = state.panel;
    var list = state.media;
    if (!list.length) return;
    if (index < 0) index = list.length - 1;
    if (index >= list.length) index = 0;
    state.mediaIndex = index;

    var img = panel.querySelector('[data-hf-qv-main]');
    if (img) {
      var changed = img.getAttribute('src') !== list[index].src;
      if (changed) img.classList.add('is-swapping');
      /* Mobil steht das Bild in 112 px, auf dem Desktop in 310 px: dem Browser
         die kleineren Fassungen anbieten, statt immer 1200 px zu laden. */
      img.setAttribute('sizes', IMG_SIZES);
      img.setAttribute('srcset', srcsetFor(list[index].src));
      if (changed) {
        img.src = list[index].src;
        img.alt = list[index].alt || '';
        if (img.complete) {
          img.classList.remove('is-swapping');
        } else {
          img.onload = function () { img.classList.remove('is-swapping'); };
        }
      }
    }

    var counter = panel.querySelector('[data-hf-qv-counter]');
    if (counter) {
      counter.textContent = (index + 1) + ' / ' + list.length;
      counter.hidden = list.length < 2;
    }

    var thumbButtons = panel.querySelectorAll('[data-hf-qv-thumb]');
    for (var t = 0; t < thumbButtons.length; t++) {
      thumbButtons[t].classList.toggle('is-active', t === index);
    }
    var dotNodes = panel.querySelectorAll('[data-hf-qv-dots] span');
    for (var d = 0; d < dotNodes.length; d++) {
      dotNodes[d].classList.toggle('is-active', d === index);
    }
  }

  function bindGallery(panel) {
    var thumbs = panel.querySelector('[data-hf-qv-thumbs]');
    if (thumbs) {
      thumbs.addEventListener('click', function (event) {
        var button = event.target.closest('[data-hf-qv-thumb]');
        if (!button) return;
        showMedia(parseInt(button.getAttribute('data-hf-qv-thumb'), 10) || 0);
      });
      thumbs.addEventListener('scroll', updateThumbFade, { passive: true });
      window.addEventListener('resize', updateThumbFade);
      buildThumbNav(panel);
    }

    var stage = panel.querySelector('.hf-qv__stage');
    if (!stage) return;
    var startX = 0;
    var startY = 0;
    var tracking = false;
    stage.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      tracking = true;
    }, { passive: true });
    stage.addEventListener('touchend', function (event) {
      if (!tracking) return;
      tracking = false;
      var touch = event.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      showMedia(state.mediaIndex + (dx < 0 ? 1 : -1));
    });
  }

  /* ------------------------------------------------------------------ Farben */

  function bindColors(panel) {
    var wrap = panel.querySelector('[data-hf-qv-colors]');
    if (!wrap) return;
    wrap.addEventListener('click', function (event) {
      var button = event.target.closest('.hf-qv__swatch');
      if (!button || button.classList.contains('is-unavailable')) return;
      var value = button.getAttribute('data-value');
      if (value === state.selected[state.colorIndex]) return;
      state.selected[state.colorIndex] = value;

      /* Auswahl der uebrigen Optionen verwerfen, wenn sie hier nicht lieferbar ist */
      for (var i = 0; i < state.selected.length; i++) {
        if (i === state.colorIndex || state.selected[i] === null) continue;
        if (!optionAvailable(i, state.selected[i])) state.selected[i] = null;
      }

      renderMedia();
      update();
    });
  }

  /* ------------------------------------------------------------ Optionsfelder */

  function fields() {
    return state.panel.querySelectorAll('[data-hf-qv-opt]');
  }

  function openField(field, openIt) {
    var head = field.querySelector('[data-hf-qv-opt-head]');
    var list = field.querySelector('[data-hf-qv-opt-list]');
    head.setAttribute('aria-expanded', openIt ? 'true' : 'false');
    list.hidden = !openIt;
  }

  function closeAllFields() {
    var list = fields();
    for (var i = 0; i < list.length; i++) openField(list[i], false);
  }

  function openNextMissing(scroll) {
    var list = fields();
    for (var i = 0; i < list.length; i++) {
      var position = parseInt(list[i].getAttribute('data-position'), 10) - 1;
      if (state.selected[position] === null) {
        closeAllFields();
        openField(list[i], true);
        list[i].classList.add('is-missing');
        if (scroll) {
          try { list[i].scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (err) {}
        }
        return true;
      }
    }
    return false;
  }

  function bindOptions(panel) {
    var list = fields();
    for (var i = 0; i < list.length; i++) {
      (function (field) {
        var head = field.querySelector('[data-hf-qv-opt-head]');
        var position = parseInt(field.getAttribute('data-position'), 10) - 1;

        head.addEventListener('click', function () {
          var isOpen = head.getAttribute('aria-expanded') === 'true';
          closeAllFields();
          openField(field, !isOpen);
        });

        field.querySelector('[data-hf-qv-opt-list]').addEventListener('click', function (event) {
          var row = event.target.closest('[data-hf-qv-opt-row]');
          if (!row || row.classList.contains('is-unavailable')) return;
          state.selected[position] = row.getAttribute('data-value');
          field.classList.remove('is-missing');
          openField(field, false);
          openNextMissing(false);
          renderMedia(true);
          update();
        });
      })(list[i]);
    }
  }

  /* ------------------------------------------------------------ Stoffmuster */

  /* Das Musterfenster (sections/hf-samples.liquid) wird wie das Panel der
     Schnellansicht per fetch geholt: /products/<handle>?view=hf-samples
     Zwei Auftritte:
       layer      - Ebene innerhalb der Schnellansicht, Kopfzeile mit Zurueck
       standalone - eigener Drawer bzw. Sheet von der Produktseite aus
     Die alte Loesung (Focals drawer-content aus snippets/pdp-samples.liquid)
     wird nicht mehr benutzt; die Ausloeser dort werden hier abgefangen. */

  var samples = null;

  function samplesUrl(productUrl) {
    return productUrl.split('?')[0] + '?view=hf-samples';
  }

  function loadSamples(productUrl) {
    var url = samplesUrl(productUrl);
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('samples ' + response.status);
        return response.text();
      })
      .then(function (text) {
        cache[url] = text;
        return text;
      });
  }

  function samplesLoader() {
    return '<div class="hf-sm"><div class="hf-sm__loading">Muster werden geladen …</div></div>';
  }

  function samplesLayer() {
    return state && state.panel ? state.panel.querySelector('[data-hf-sm-layer]') : null;
  }

  function openSamplesLayer(productUrl) {
    var host = state && state.panel;
    if (!host) return;

    var layer = samplesLayer();
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'hf-sm-layer';
      layer.setAttribute('data-hf-sm-layer', '');
      host.appendChild(layer);
    }
    layer.hidden = false;
    layer.innerHTML = samplesLoader();
    /* Die Klasse gibt dem Fenster mehr Hoehe, solange die Ebene offen ist
       (siehe hf-quickview-panel.css). */
    win.classList.add('hf-qv--samples-layer');
    /* Reflow erzwingen statt requestAnimationFrame: in versteckten Tabs laufen
       keine Render-Frames, die Ebene bliebe sonst im Ladezustand haengen. */
    void layer.offsetHeight;
    layer.classList.add('is-open');

    loadSamples(productUrl).then(function (html) {
      if (layer.hidden) return;
      layer.innerHTML = html;
      initSamples(layer.querySelector('[data-hf-sm-panel]'), 'layer');
    })['catch'](function () {
      window.location.href = '/collections/stoffmuster';
    });
  }

  function closeSamplesLayer() {
    var layer = samplesLayer();
    if (!layer) return;
    layer.classList.remove('is-open');
    if (win) win.classList.remove('hf-qv--samples-layer');
    samples = null;
    window.setTimeout(function () {
      if (layer && !layer.classList.contains('is-open')) layer.hidden = true;
    }, 300);
  }

  function openSamplesStandalone(productUrl, trigger) {
    buildWindow();
    openerEl = trigger || null;
    currentUrl = null;
    state = null;
    win.classList.add('hf-qv--samples');
    if (!win.hasAttribute('open')) {
      document.documentElement.classList.add(LOCK_CLASS, 'lock-all');
      win.setAttribute('open', '');
    }
    slot.innerHTML = samplesLoader();

    loadSamples(productUrl).then(function (html) {
      if (!win.hasAttribute('open')) return;
      slot.innerHTML = html;
      initSamples(slot.querySelector('[data-hf-sm-panel]'), 'standalone');
    })['catch'](function () {
      window.location.href = '/collections/stoffmuster';
    });
  }

  function initSamples(panel, mode) {
    if (!panel) return;
    panel.classList.add(mode === 'layer' ? 'hf-sm--layer' : 'hf-sm--standalone');

    samples = {
      panel: panel,
      mode: mode,
      max: parseInt(panel.getAttribute('data-max'), 10) || 4
    };

    var back = panel.querySelector('[data-hf-sm-back]');
    var closeBtn = panel.querySelector('[data-hf-sm-close]');
    if (back && mode === 'layer') {
      back.hidden = false;
      back.addEventListener('click', closeSamplesLayer);
      /* Die Rubrik wandert in den Zurueck-Knopf: Pfeil und Wort sind dann ein
         einziges, deutlich groesseres Ziel. */
      var rubric = panel.querySelector('.hf-sm__rubric');
      if (rubric) {
        back.appendChild(rubric);
        back.classList.add('hf-sm__back--wide');
        back.setAttribute('aria-label', 'Zurück zum Produkt');
      }
    }
    if (closeBtn) closeBtn.addEventListener('click', close);

    var grid = panel.querySelector('[data-hf-sm-grid]');
    if (grid) {
      grid.addEventListener('click', function (event) {
        var tile = event.target.closest('[data-hf-sm-tile]');
        if (!tile || tile.classList.contains('is-blocked')) return;
        tile.setAttribute('aria-pressed', tile.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        updateSamples();
      });
    }

    var add = panel.querySelector('[data-hf-sm-add]');
    if (add) add.addEventListener('click', addSamples);

    updateSamples();
    window.setTimeout(function () {
      var first = mode === 'layer' ? back : closeBtn;
      if (first) first.focus();
    }, 0);
  }

  function chosenTiles() {
    return samples.panel.querySelectorAll('[data-hf-sm-tile][aria-pressed="true"]');
  }

  function updateSamples() {
    if (!samples) return;
    var panel = samples.panel;
    var tiles = panel.querySelectorAll('[data-hf-sm-tile]');
    var chosen = chosenTiles();
    var full = chosen.length >= samples.max;
    var sum = 0;

    for (var i = 0; i < chosen.length; i++) {
      sum += parseInt(chosen[i].getAttribute('data-price'), 10) || 0;
    }
    for (var t = 0; t < tiles.length; t++) {
      var picked = tiles[t].getAttribute('aria-pressed') === 'true';
      tiles[t].classList.toggle('is-blocked', full && !picked);
    }

    var counter = panel.querySelector('[data-hf-sm-counter]');
    if (counter) {
      var template = counter.getAttribute('data-template') || '{n} von {max} gewählt';
      var text = template.replace('{n}', chosen.length).replace('{max}', samples.max);
      counter.textContent = chosen.length ? text + ' · ' + formatMoney(sum) : text;
    }

    var add = panel.querySelector('[data-hf-sm-add]');
    if (add) {
      add.disabled = chosen.length === 0;
      add.textContent = chosen.length
        ? add.getAttribute('data-label-filled') + ' · ' + formatMoney(sum)
        : add.getAttribute('data-label-empty');
    }
  }

  function addSamples() {
    if (!samples) return;
    var panel = samples.panel;
    var chosen = chosenTiles();
    if (!chosen.length) return;

    var items = [];
    for (var i = 0; i < chosen.length; i++) {
      items.push({ id: Number(chosen[i].getAttribute('data-variant-id')), quantity: 1 });
    }

    var loading = panel.querySelector('[data-hf-sm-loading]');
    if (loading) loading.hidden = false;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart ' + response.status);
        return response.json();
      })
      .then(function () {
        if (loading) loading.hidden = true;
        /* Dieselben Ereignisse wie die uebrige Warenkorb-Logik des Themes */
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        close();
      })
      ['catch'](function () {
        if (loading) loading.hidden = true;
        var box = panel.querySelector('[data-hf-sm-voucher]');
        var text = panel.querySelector('[data-hf-sm-voucher-text]');
        if (box) box.classList.add('is-error');
        if (text) text.textContent = panel.getAttribute('data-error') || 'Bitte versuchen Sie es noch einmal.';
      });
  }

  /* Ausloeser der Produktseite abfangen, damit das alte Fenster zubleibt */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[aria-controls$="-samples-drawer"], [aria-controls$="-samples-popover"]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    openSamplesStandalone(window.location.pathname, trigger);
  }, true);

  /* ------------------------------------------------------------ Bewertungen */

  function reviewPanel() {
    return state && state.panel ? state.panel.querySelector('[data-hf-qv-reviewpanel]') : null;
  }

  function bindReviews(panel) {
    var rp = panel.querySelector('[data-hf-qv-reviewpanel]');
    if (!rp) return;
    var openers = panel.querySelectorAll('[data-hf-qv-reviews-open]');
    for (var i = 0; i < openers.length; i++) {
      openers[i].addEventListener('click', openReviews);
    }
    var back = rp.querySelector('[data-hf-qv-reviews-close]');
    if (back) {
      back.addEventListener('click', closeReviews);
      /* Wie im Musterfenster: die Ueberschrift wandert in den Zurueck-Knopf,
         Pfeil und Wort sind dann ein einziges, groesseres Ziel. */
      var title = rp.querySelector('.hf-qv-reviews__title');
      if (title) {
        back.appendChild(title);
        back.classList.add('hf-qv-reviews__back--wide');
      }
    }
  }

  function openReviews() {
    var rp = reviewPanel();
    if (!rp) return;
    rp.hidden = false;
    void rp.offsetHeight;
    rp.classList.add('is-open');
    window.setTimeout(function () {
      var back = rp.querySelector('[data-hf-qv-reviews-close]');
      if (back) back.focus();
    }, 0);
    loadReviews();
  }

  function closeReviews() {
    var rp = reviewPanel();
    if (!rp) return;
    rp.classList.remove('is-open');
    window.setTimeout(function () {
      if (rp && !rp.classList.contains('is-open')) rp.hidden = true;
    }, 300);
  }

  function stars(rating) {
    var out = '';
    for (var i = 1; i <= 5; i++) out += (i <= Math.round(rating || 0) ? '★' : '☆');
    return out;
  }

  function escapeHtml(text) {
    return String(text == null ? '' : text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function loadReviews() {
    if (!state || state.reviewsLoaded) return;
    state.reviewsLoaded = true;

    var list = state.panel.querySelector('[data-hf-qv-reviewslist]');
    var sku = state.config.reviewSku || '';
    if (!list) return;
    list.innerHTML = '<p class="hf-qv-reviews__state">Bewertungen werden geladen</p>';

    var store = (window.Shopify && window.Shopify.shop) || 'hoffmann-8509.myshopify.com';
    var url = 'https://api.reviews.io/timeline/data?type=product_review&store=' +
      encodeURIComponent(store) +
      '&sort=date_desc&page=1&per_page=30&lang=de&sku=' + encodeURIComponent(sku);

    fetch(url)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var items = (data && data.timeline) || [];
        if (!items.length) {
          list.innerHTML = '<p class="hf-qv-reviews__state">Für dieses Produkt liegen noch keine Bewertungen vor.</p>';
          return;
        }
        var html = '';
        for (var i = 0; i < items.length; i++) {
          var r = items[i]._source || items[i];
          var text = (r.comments || '').trim();
          var date = (r.date_created || r.date_updated || '').slice(0, 10).split('-');
          html += '<div class="hf-qv-reviews__item">' +
            '<div class="hf-qv-reviews__meta">' +
            '<span class="hf-qv-reviews__stars" aria-label="' + (r.rating || 0) + ' von 5 Sternen">' + stars(r.rating) + '</span>' +
            '<span class="hf-qv-reviews__author">' + escapeHtml(r.author || 'Anonym') + '</span>' +
            (date.length === 3 ? '<span class="hf-qv-reviews__date">' + date[2] + '.' + date[1] + '.' + date[0] + '</span>' : '') +
            '</div>' +
            (r.review_title ? '<p class="hf-qv-reviews__text"><strong>' + escapeHtml(r.review_title) + '</strong></p>' : '') +
            (text ? '<p class="hf-qv-reviews__text">' + escapeHtml(text) + '</p>' : '') +
            (r.product_name ? '<span class="hf-qv-reviews__variant">' + escapeHtml(r.product_name) + '</span>' : '') +
            '</div>';
        }
        list.innerHTML = html || '<p class="hf-qv-reviews__state">Für dieses Produkt liegen noch keine Bewertungen vor.</p>';
      })
      ['catch'](function () {
        list.innerHTML = '<p class="hf-qv-reviews__state">Die Bewertungen lassen sich gerade nicht laden.</p>';
      });
  }

  /* --------------------------------------------------------------- Menge --- */

  function bindQuantity(panel) {
    var input = panel.querySelector('[data-hf-qv-qtyinput]');
    if (!input) return;
    var buttons = panel.querySelectorAll('[data-hf-qv-qty]');
    for (var i = 0; i < buttons.length; i++) {
      (function (button) {
        button.addEventListener('click', function () {
          var step = parseInt(button.getAttribute('data-hf-qv-qty'), 10) || 0;
          setQuantity((parseInt(input.value, 10) || 1) + step);
        });
      })(buttons[i]);
    }
    input.addEventListener('change', function () {
      setQuantity(parseInt(input.value, 10) || 1);
    });
  }

  function setQuantity(value) {
    var input = state.panel.querySelector('[data-hf-qv-qtyinput]');
    if (!input) return;
    if (value < 1) value = 1;
    var max = parseInt(input.getAttribute('max'), 10);
    if (max && value > max) value = max;
    input.value = value;
    update();
  }

  /* ------------------------------------------------------------ Kaufen ----- */

  /* Der Guard haengt am document in der Capture-Phase, damit er vor Focals
     ProductForm laeuft: sonst schickt Focal die unvollstaendige Wahl ab. */
  document.addEventListener('submit', function (event) {
    if (!state || !win || !win.hasAttribute('open')) return;
    if (!state.panel.contains(event.target)) return;
    if (currentVariant()) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    openNextMissing(true);
  }, true);

  /* Nach dem Hinzufuegen schliesst das Fenster, der Warenkorb uebernimmt.
     cart:refresh feuert custom.js nach der Musterbestellung. */
  document.addEventListener('variant:added', function () {
    if (win && win.hasAttribute('open')) close();
  });
  document.documentElement.addEventListener('cart:refresh', function () {
    if (win && win.hasAttribute('open')) close();
  });

  /* --------------------------------------------------------------- Rendern -- */

  function update() {
    var panel = state.panel;
    var config = state.config;
    var variant = currentVariant();
    var quantityInput = panel.querySelector('[data-hf-qv-qtyinput]');
    var quantity = quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1;
    var anyAvailable = false;
    for (var av = 0; av < config.variants.length; av++) {
      if (config.variants[av].available) { anyAvailable = true; break; }
    }
    var soldOut = (!!variant && variant.available === false) || !anyAvailable;
    var isCustom = config.customOnly || (!!variant && String(variant.customized) === '1');

    /* Farbpunkte */
    if (state.colorIndex > -1) {
      var swatches = panel.querySelectorAll('.hf-qv__swatch');
      for (var s = 0; s < swatches.length; s++) {
        var colorValue = swatches[s].getAttribute('data-value');
        var chosen = colorValue === state.selected[state.colorIndex];
        swatches[s].setAttribute('aria-checked', chosen ? 'true' : 'false');
        swatches[s].classList.toggle('is-unavailable', !optionAvailable(state.colorIndex, colorValue));
      }
      var colorValueEl = panel.querySelector('[data-hf-qv-colorvalue]');
      if (colorValueEl) colorValueEl.textContent = state.selected[state.colorIndex] || '';
    }

    /* Optionsfelder */
    var list = fields();
    for (var f = 0; f < list.length; f++) {
      var field = list[f];
      var position = parseInt(field.getAttribute('data-position'), 10) - 1;
      var value = state.selected[position];
      var labelEl = field.querySelector('[data-hf-qv-opt-label]');
      var noteEl = field.querySelector('[data-hf-qv-opt-note]');
      var rows = field.querySelectorAll('[data-hf-qv-opt-row]');

      for (var r = 0; r < rows.length; r++) {
        var rowValue = rows[r].getAttribute('data-value');
        var rowPrice = priceFor(position, rowValue);
        var rowPriceEl = rows[r].querySelector('[data-hf-qv-rowprice]');
        if (rowPriceEl) rowPriceEl.textContent = rowPrice === null ? '' : formatMoney(rowPrice);
        rows[r].classList.toggle('is-unavailable', !optionAvailable(position, rowValue));
        rows[r].classList.toggle('is-chosen', rowValue === value);
      }

      if (value) {
        field.classList.add('is-chosen');
        labelEl.textContent = value;
        var note = '';
        for (var rr = 0; rr < rows.length; rr++) {
          if (rows[rr].getAttribute('data-value') === value) {
            var hint = rows[rr].querySelector('.hf-qv-opt__hint');
            note = hint ? hint.textContent : '';
          }
        }
        noteEl.textContent = note;
        noteEl.hidden = !note;
      } else {
        field.classList.remove('is-chosen');
        labelEl.textContent = field.getAttribute('data-name') + ' wählen';
        noteEl.hidden = true;
      }
    }

    /* Preiszeile */
    var priceValue = panel.querySelector('[data-hf-qv-price]');
    var shownPrice = variant ? variant.price * quantity : minPrice();
    if (priceValue && shownPrice !== null) {
      priceValue.textContent = (variant ? '' : 'ab ') + formatMoney(shownPrice);
    }

    /* Sonderanfertigung */
    var box = panel.querySelector('[data-hf-qv-custombox]');
    if (box) {
      box.hidden = !isCustom || soldOut;
      var dateEl = box.querySelector('[data-hf-qv-date]');
      if (dateEl && !box.hidden && !dateEl.textContent) {
        var days = parseInt(dateEl.getAttribute('data-days'), 10) || 16;
        var date = new Date();
        date.setDate(date.getDate() + days);
        dateEl.textContent = date.toLocaleDateString('de-DE', { day: 'numeric', month: 'long' });
      }
    }
    var customWrap = panel.querySelector('.hf-qv__custom');
    if (customWrap) customWrap.hidden = !box || box.hidden;

    /* Kaufbutton */
    var atc = panel.querySelector('[data-hf-qv-atc]');
    if (atc) {
      var labelEl2 = atc.querySelector('[data-hf-qv-atc-label]');
      var priceEl2 = atc.querySelector('[data-hf-qv-atc-price]');
      var label = soldOut
        ? atc.getAttribute('data-label-soldout')
        : (isCustom ? atc.getAttribute('data-label-custom') : atc.getAttribute('data-label-default'));
      if (labelEl2) labelEl2.textContent = label;
      if (priceEl2) {
        priceEl2.textContent = (soldOut || isCustom || shownPrice === null)
          ? ''
          : (variant ? '' : 'ab ') + formatMoney(shownPrice);
      }
      atc.disabled = soldOut;
      atc.classList.toggle('is-sold-out', soldOut);
      atc.setAttribute('data-button-content', label);
    }

    /* Menge: Obergrenze aus dem Lagerbestand ist nicht Teil des Storefronts,
       deshalb nur Minimum 1 sperren. */
    var minus = panel.querySelector('[data-hf-qv-qty="-1"]');
    if (minus) minus.disabled = quantity <= 1;

    /* Express-Zahlung: nur bei vollstaendiger, lieferbarer, regulaerer Wahl */
    var express = panel.querySelector('[data-hf-qv-express]');
    if (express) express.hidden = !variant || soldOut || isCustom;

    /* Variante ins Formular */
    var idInput = panel.querySelector('[data-hf-qv-id]');
    if (idInput) idInput.value = variant ? variant.id : '';
  }

  /* ------------------------------------------------------- Ausloeser fangen */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(TRIGGER);
    if (!trigger) return;
    var url = productUrlFrom(trigger);
    if (!url) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    open(url, trigger);
  }, true);

  /* Sicherheitsnetz: falls Focals alte Schnellansicht doch geoeffnet wird,
     bleibt sie zu, solange dieses Fenster offen ist. */
  document.addEventListener('openable-element:open', function (event) {
    if (!win || !win.hasAttribute('open')) return;
    var target = event.target;
    if (target && target.tagName && /^QUICK-BUY-/.test(target.tagName)) {
      target.open = false;
    }
  }, true);
})();
